export default __webpack_public_path__ + "static/bg_header-fc9bf1e0c854587196415e84322c973e.png";